import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { socketio } from '../api/socket.api';
import { SignInDto } from '../model/user.dto';
import { authAPI } from '../api/axiosIndex';
import { errorMsgRecoil } from '../atom/ModalAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userIdState } from '../atom/TokenAtom';
import { socketInitializeRecoil } from '../atom/CommonAtom';

const AutoLogin = () => {
  const navigate = useNavigate();

  const setError = useSetRecoilState(errorMsgRecoil);
  const socketInitialize = useRecoilValue(socketInitializeRecoil);
  const [userId, setUserId] = useRecoilState(userIdState);

  const autoLogin = async () => {
    const userInfor = JSON.parse(String(localStorage.getItem('userInfor')));

    try {
      const dto: SignInDto = {
        passid: userInfor.passid,
        password: userInfor.password,
      };

      const token = await authAPI.signIn(dto);

      sessionStorage.setItem('accessToken', token.data.accessToken);
      sessionStorage.setItem('refreshToken', token.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + token.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + token.data.refreshExpire * 1000).toString(),
      );

      const myInfor = await authAPI.getMyInfor();
      setUserId(myInfor.data.id);

      await socketio.signin(token.data.accessToken);

      navigate('/worknummanage');
    } catch {
      sessionStorage.clear();
      localStorage.clear();
      setError('자동 로그인에 실패했습니다.\n다시 로그인 해주세요.');
      navigate('/login');
    }
  };

  useEffect(() => {
    if (socketInitialize) {
      autoLogin();
    }
  }, [socketInitialize]);

  return <></>;
};

export default AutoLogin;
